import PropTypes from 'prop-types'
import axios from 'axios'

export default function ChangePasswordAPI ( props ) {
    const { apiUrl, userId,password,confirmPassword,hiddenValue, secureId,email } = props
    const formData  = new FormData()
    formData.append( 'UserId', userId )
    formData.append( 'Password', password )
    formData.append( 'ConfirmPassword', confirmPassword )
    formData.append( 'HiddenValue', hiddenValue )
    formData.append( 'SecureId', secureId )
    formData.append( 'Email', email )

    return axios.post(
        apiUrl,
        formData,
        { 
            withCredentials: true 
        } )
        .then( response => {
            return response.data
        } )
        .catch( e => {
            throw Error( e )
        } )
}

ChangePasswordAPI.propTypes = {
    userId : PropTypes.string.isRequired,
    password : PropTypes.string.isRequired,
    confirmPassword : PropTypes.string.isRequired,
    hiddenValue : PropTypes.string.isRequired,
    secureId :PropTypes.string.isRequired,
    email : PropTypes.string.isRequired,
    apiUrl: PropTypes.string.isRequired
}
